var exports = {
  "MY": "OAuthAuthorizePage.module__page___VlkzZH",
  "Un": "OAuthAuthorizePage.module__errorContainer___VlkzZH",
  "ow": "OAuthAuthorizePage.module__errorContent___VlkzZH",
  "JU": "OAuthAuthorizePage.module__errorTitle___VlkzZH",
  "kc": "OAuthAuthorizePage.module__errorText___VlkzZH",
  "d1": "OAuthAuthorizePage.module__heroCard___VlkzZH",
  "iC": "OAuthAuthorizePage.module__heroCopy___VlkzZH",
  "ZY": "OAuthAuthorizePage.module__heroTitle___VlkzZH",
  "fd": "OAuthAuthorizePage.module__heroDescription___VlkzZH",
  "$2": "OAuthAuthorizePage.module__cardGrid___VlkzZH",
  "ts": "OAuthAuthorizePage.module__sectionDivider___VlkzZH",
  "nd": "OAuthAuthorizePage.module__panel___VlkzZH",
  "bV": "OAuthAuthorizePage.module__sectionHeader___VlkzZH",
  "Gf": "OAuthAuthorizePage.module__sectionTitle___VlkzZH",
  "yV": "OAuthAuthorizePage.module__sectionDescription___VlkzZH",
  "s0": "OAuthAuthorizePage.module__inlineStatus___VlkzZH",
  "Jb": "OAuthAuthorizePage.module__scopeList___VlkzZH",
  "_9": "OAuthAuthorizePage.module__permissionScrollContainer___VlkzZH",
  "C6": "OAuthAuthorizePage.module__permissionScroller___VlkzZH",
  "Mg": "OAuthAuthorizePage.module__permissionList___VlkzZH",
  "ce": "OAuthAuthorizePage.module__permissionRow___VlkzZH",
  "Ck": "OAuthAuthorizePage.module__permissionLabel___VlkzZH",
  "rJ": "OAuthAuthorizePage.module__scopeRow___VlkzZH",
  "BB": "OAuthAuthorizePage.module__scopeHeading___VlkzZH",
  "OK": "OAuthAuthorizePage.module__scopeName___VlkzZH",
  "RJ": "OAuthAuthorizePage.module__scopeDescription___VlkzZH",
  "Pp": "OAuthAuthorizePage.module__scopeChip___VlkzZH",
  "p$": "OAuthAuthorizePage.module__emptyState___VlkzZH",
  "uL": "OAuthAuthorizePage.module__caution___VlkzZH",
  "iB": "OAuthAuthorizePage.module__dangerNotice___VlkzZH",
  "mW": "OAuthAuthorizePage.module__successScreen___VlkzZH",
  "n7": "OAuthAuthorizePage.module__successIconCircle___VlkzZH",
  "FU": "OAuthAuthorizePage.module__successIcon___VlkzZH",
  "QK": "OAuthAuthorizePage.module__successTitle___VlkzZH",
  "s3": "OAuthAuthorizePage.module__successSubtitle___VlkzZH",
  "cs": "OAuthAuthorizePage.module__successAction___VlkzZH",
  "By": "OAuthAuthorizePage.module__guildOption___VlkzZH",
  "rZ": "OAuthAuthorizePage.module__guildValue___VlkzZH",
  "XN": "OAuthAuthorizePage.module__guildAvatar___VlkzZH",
  "oM": "OAuthAuthorizePage.module__guildAvatarPlaceholder___VlkzZH",
  "p2": "OAuthAuthorizePage.module__guildOptionLabel___VlkzZH",
  "RG": "OAuthAuthorizePage.module__guildOptionDisabled___VlkzZH",
  "p4": "OAuthAuthorizePage.module__guildOptionNotice___VlkzZH",
  "A2": "OAuthAuthorizePage.module__actionSection___VlkzZH",
  "PJ": "OAuthAuthorizePage.module__footerText___VlkzZH",
  "o1": "OAuthAuthorizePage.module__actions___VlkzZH",
  "hP": "OAuthAuthorizePage.module__actionButton___VlkzZH",
  "U6": "OAuthAuthorizePage.module__authorizingAccount___VlkzZH",
  "HI": "OAuthAuthorizePage.module__authorizingAccountAvatar___VlkzZH",
  "vZ": "OAuthAuthorizePage.module__authorizingAccountText___VlkzZH",
};

module.exports = exports;
